module.exports = __webpack_public_path__ + "images/breadcrumb-caret.f5d4f21a75.svg";